
"use client";

import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export default function PrivacyClient() {
    return (
        <div className="flex flex-col min-h-screen bg-background">
            <Header />
            <main className="flex-grow pt-32 pb-24">
                <div className="container mx-auto px-6 max-w-4xl">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-[10px] uppercase tracking-[0.3em] font-black">
                            Legal
                        </Badge>
                        <h1 className="font-headline text-5xl md:text-7xl font-black text-foreground mb-12 tracking-tight">
                            Privacy <span className="text-primary italic font-normal">Policy</span>
                        </h1>

                        <Card className="bg-card shadow-soft border-none rounded-[2.5rem] p-4 md:p-8">
                            <CardContent className="space-y-10">
                                <div>
                                    <p className="text-lg text-muted-foreground font-medium leading-relaxed">
                                        Your privacy is of paramount importance to us. This Privacy Policy outlines how Bay Valley Pups collects, uses, and protects your information when you visit our website or inquire about a puppy.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">1. Information Collection</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        We collect information you provide directly to us. This includes:
                                    </p>
                                    <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                                        <li><strong>Personal Identification:</strong> Name, email address, phone number, and location provided in our contact forms or applications.</li>
                                        <li><strong>Preferences:</strong> Information about your household, lifestyle, and puppy preferences to help us match you with the right dog.</li>
                                    </ul>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">2. Use of Information</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        We use the information we collect to:
                                    </p>
                                    <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                                        <li>Process your adoption application and communicate with you about available puppies.</li>
                                        <li>Schedule visits and coordinate pickups.</li>
                                        <li>Send updates about future litters if you have opted into our waitlist.</li>
                                        <li>Improve our website functionality and user experience.</li>
                                    </ul>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">3. Information Sharing</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners and advertisers for the purposes outlined above.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">4. Cookies</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        Our website may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. You may choose to set your web browser to refuse cookies or to alert you when cookies are being sent.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">5. Data Protection</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        We implement industry-standard security measures to safeguard your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                                    </p>
                                </div>
                            </CardContent>
                        </Card>
                    </motion.div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
